/**
 * @summary - Component that Provides Stock Details Edit Tab
 * @author Yuvasri S
 * @since 2024-07-08
 */
import React, { useEffect } from 'react';
import { Box, Grid, Typography, Paper, Button } from '@mui/material';
import { useDispatch } from 'react-redux';
import CloseButton from '../commoncomponents/CloseButton';
import { DefaultCard } from '../../assets/styled-components/card';
import { MasterGraph } from "../../utility/apiURLS";
import axios from 'axios';
import { updateCreateStockRegister, setSrPrimaryId } from '../../redux/reducers/StockRegisterReducer/stockSlice';
import { getAuthToken } from "../../utility/tokenUtility";
import { useNavigate } from "react-router";

const StockDetailsEditTab = ({ stockDetails, onStockDetailsFetch }) => {
    const token = getAuthToken("id_token");
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const {
        srId,
        itemcode,
        itemCodeDesc,
        itemType,
        service,
        status,
        workGroup,
        quantity,
        minUnit,
        maxUnit,
        minPrice,
        maxPrice,
        currentStockLevel
    } = stockDetails;

    const fetchItemDetails = async (itemCode) => {
        if (!itemCode) {
            console.error("Item code is empty, cannot fetch item details.");
            return;
        }

        try {
            const response = await axios.get(
                `${MasterGraph}/api/GraphStockRegister/GetStockRegisterByItemcode/${itemCode}`,
                config
            );

            const itemData = response.data[0];
            const stockData = itemData.masimsstockregisters[0];
            const quantityOptions = {
                1: 'Unit',
                2: 'Nos',
                3: 'Kg'
            };

            const updatedDetails = {
                srId: stockData.id,
                itemcode: itemData.itemcode,
                itemCodeDesc: itemData.itemDescription,
                itemType: itemData.itemType,
                service: itemData.itemservice,
                status: itemData.isactive ? 'Active' : 'Inactive',
                workGroup: itemData.workgroup,
                quantity: quantityOptions[stockData.quantity],
                minUnit: itemData.minimumstock,
                maxUnit: itemData.maximumstock,
                minPrice: stockData.minpriceperunit,
                maxPrice: stockData.maxpriceperunit,
                currentStockLevel: stockData.currentstocklevel,
            };
            dispatch(updateCreateStockRegister(updatedDetails));
            onStockDetailsFetch(updatedDetails);
            dispatch(setSrPrimaryId(stockData.id))

        } catch (error) {
            console.error("Error fetching item details:", error);
        }
    }
    useEffect(() => {
        if (stockDetails.itemcode) {
            fetchItemDetails(stockDetails.itemcode);
        }
    }, [stockDetails.itemcode]);

    const handleCancel = () => {
        navigate(-1, { replace: true });
    };


    const details = [
        { label: 'Item Code', value: itemcode },
        { label: 'Item Description', value: itemCodeDesc },
        { label: 'Item Type', value: itemType },
        { label: 'Work Group', value: workGroup },
        { label: 'Service', value: service },
        { label: 'Status', value: status },
        { label: 'Quantity', value: quantity },
        { label: 'Min Unit', value: minUnit },
        { label: 'Max Unit', value: maxUnit },
        { label: 'Min Price per unit (RM)', value: minPrice },
        { label: 'Max Price per unit (RM)', value: maxPrice },
        { label: 'Current Stock Level', value: currentStockLevel },
    ];

    return (
        <>
            <DefaultCard>
                <Paper elevation={3} sx={{ p: 3, backgroundColor: '#f5f5f5' }}>
                    <Typography variant="h5" gutterBottom>
                        Stock Details
                    </Typography>
                    <Box mb={3} />
                    <Grid container spacing={2}>
                        {details.map((detail, index) => (
                            <Grid item xs={12} sm={6} md={4} lg={2.4} key={index}>
                                <Box>
                                    <Typography variant="body2" sx={{ color: 'grey' }}>
                                        {detail.label}
                                    </Typography>
                                    <Typography variant="body1" fontWeight="bold">
                                        {detail.value}
                                    </Typography>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Paper>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                    <Button variant="outlined" sx={{ m: 1 }} onClick={handleCancel}>
                        Back
                    </Button>
                </Box>
            </DefaultCard>
        </>
    );
};

export default StockDetailsEditTab;
